import { JobListingResource } from 'util/resources/JobListing';

type JobInfoProps = {
  jobListing: JobListingResource;
};

export const JobInfo = (props: JobInfoProps) => {
  const { jobListing } = props;

  return (
    <div className="text-center">
      <p className="font-bold">{jobListing.title}</p>
      <p className="text-sm text-neutral-darker">{jobListing.getLocationText()}</p>
    </div>
  );
};
